import { FormikTouched, FormikErrors, FormikHelpers } from 'formik';

export function IsInvalid<TValues>(
	key: keyof TValues,
	errors: FormikErrors<TValues>,
	touched: FormikTouched<TValues>
): boolean {
	return touched[key] && errors[key] !== undefined;
}

export interface MutateOnSubmitVariables<TFormValues> {
	values: TFormValues;
	helpers: FormikHelpers<TFormValues>;
}

export function MutateOnSubmit<TFormValues>(mutate: (variables: MutateOnSubmitVariables<TFormValues>) => void) {
	return (values: TFormValues, helpers: FormikHelpers<TFormValues>) => mutate({ values, helpers });
}

export interface OnChangeTarget extends EventTarget {
	name: string;
	value: string;
}
